export const LocalStorageKeysConstant = {
  tokenUserLogin: 'intelidente-token-login',
  calendar: 'calendario',
};
